import { render } from "./Comparativas.vue?vue&type=template&id=02c29aa3"
import script from "./Comparativas.vue?vue&type=script&lang=js"
export * from "./Comparativas.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__